import { useCallback, useEffect, useState } from 'react';
import { useAppContext } from '~/contexts';

// Fast polling stays on either way: it follows the user's own upload, so it is not the
// unrequested auto-update the preference turns off.

export const usePollInterval = (requestedInterval: number, fastInterval: number) => {
  // The profile's auto-refresh preference turns the steady-state polling off.
  const { currentUser } = useAppContext();
  const defaultInterval = currentUser.autoRefresh ? requestedInterval : 0;
  const [deadline, setDeadline] = useState(0);
  const [pollInterval, setPollInterval] = useState(defaultInterval);

  useEffect(() => {
    const ms = deadline - Date.now();
    if (ms < 0) return undefined;

    const timeout = setTimeout(() => setPollInterval(defaultInterval), ms);
    setPollInterval(fastInterval);

    return () => clearTimeout(timeout);
  }, [deadline, defaultInterval, fastInterval]);

  const setFastPolling = useCallback(
    (seconds: number) => setDeadline(Date.now() + 1_000 * seconds),
    [],
  );

  return { pollInterval, setFastPolling };
};
